import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import SuggestionModal from './SuggestionModal';
export default class OtherCard extends Component {
  openModal(category) {
    app.modal.show(SuggestionModal, {
      category
    });
  }
  view() {
    const category = this.attrs.category;
    const userPendingCount = category.userPendingSuggestionsCount() || 0;
    const userVoteCount = (category.userVoteIds() || []).length;
    const votesPerCategory = parseInt(app.forum.attribute('awardsVotesPerCategory') || '1', 10);
    const isUnlimited = votesPerCategory === 0;
    const remainingSlots = isUnlimited ? Infinity : votesPerCategory - userVoteCount - userPendingCount;
    const hasNoRemaining = !isUnlimited && remainingSlots <= 0;
    return m("div", {
      className: `NomineeCard NomineeCard--other NomineeCard--clickable ${hasNoRemaining ? 'NomineeCard--exhausted' : ''}`,
      onclick: () => this.openModal(category),
      role: "button",
      tabindex: 0,
      onkeydown: e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.openModal(category);
        }
      }
    }, m("div", {
      className: "NomineeCard-image"
    }, m("div", {
      className: "NomineeCard-placeholder"
    }, m("i", {
      className: hasNoRemaining ? 'fas fa-list' : 'fas fa-plus'
    }))), m("div", {
      className: "NomineeCard-content"
    }, m("h3", {
      className: "NomineeCard-title"
    }, app.translator.trans('huseyinfiliz-awards.forum.other.suggest')), m("p", {
      className: "NomineeCard-description"
    }, userPendingCount > 0 ? app.translator.trans('huseyinfiliz-awards.forum.other.pending_count', {
      count: userPendingCount
    }) : hasNoRemaining ? app.translator.trans('huseyinfiliz-awards.forum.other.no_remaining') : isUnlimited ? app.translator.trans('huseyinfiliz-awards.forum.other.click_to_suggest') : app.translator.trans('huseyinfiliz-awards.forum.other.remaining', {
      count: remainingSlots
    }))));
  }
}
flarum.reg.add('huseyinfiliz-awards', 'forum/components/OtherCard', OtherCard);